import { Component } from '@angular/core';

@Component({
  selector: 't-local-icon',
  standalone: true,
  imports: [],
  templateUrl: './local-icon.component.html',
  styleUrl: './local-icon.component.css',
  host: { hostID: crypto.randomUUID().toString() },
})
export class LocalIconComponent {}
